module.exports = __webpack_public_path__ + "static/media/m14cr0.3f1d9cc0.png";